import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Context } from "../contexts/AppContext";
import { getData, postData, putData } from "../../lib/utils";
import { captureFrame } from '../../lib/common';
import { ToastContainer, toast } from "react-toastify";
import { faTrash, faSpinner } from "@fortawesome/free-solid-svg-icons";
import {
 
  faImage,
} from "@fortawesome/free-solid-svg-icons";
import UploadImageBg from '../Gallery/UploadImageBg';
import UploadImageVideoThumbnail from '../Gallery/UploadImageVideoThumbnail';


function VideoGeneralSetting(props) {

  console.log("PPPPPPPPPPPPPPPPP ",props)
  const [videoTitle, setVideoTitle] = useState('');
  const { value } = useContext(Context);
  const [appState, setAppState] = value;

  //console.log("App stagte ",appState)

  const canvasRef = useRef(null);
  const [imageSrc, setImageSrc] = useState(null);
  
  const [isUploading, setIsUploading] = useState(false);

useEffect(() => {
  const currentTitle = appState?.videoArr[appState?.currentVideoId]?.title || '';
  setVideoTitle(currentTitle);
}, [appState?.currentVideoId, appState?.videoArr]);

  useEffect(() => {
  if (!appState?.currentDBVideoId) return;

  const checkThumbnail = async () => {

    console.log("PPPPP ",appState)

    const currentVideo = appState.videoArr?.find(
  (video) => video._id === appState.currentDBVideoId
);

const thumbnail = currentVideo?.thumbnail ?? null;

    const fileName = `${thumbnail}`;
    const res = await postData("products/check-file", {
      fileName,
    });

    if (res?.exists) {
          console.log("CHECK THUMBanil for general setting ",res)
      setImageSrc(
        `${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${fileName}`
      );
    }
  };

  checkThumbnail();

  return () => {}; // ✅ safe cleanup
}, [appState?.currentDBVideoId]);


  
 const imgUploadedDone = async (file) => {
    setIsUploading(false);
    
   
const filePath = `${appState.adminDetails.id}/${appState.currentFolderData.id}/${appState.currentGalleryData._id}/${appState.currentDBVideoId}/${file.name}`;
      const json = await putData(`videos/updateVideo/${appState.currentDBVideoId}`, {
                        thumbnail: filePath 
                      });
       if (json) {     

             const updatedAppState = {
                          ...appState, // Keep other properties the same
                        currentVideoThumbnail :filePath
                        };
                        
                        //console.log("Updated AppState:", updatedAppState); // Log final state
                        
                  setImageSrc(`${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${filePath}`);

                        setAppState(updatedAppState);
                      
       } 
 }

   const imgOnPrg = () => {
    setIsUploading(true);
  };
  const uploadFailed = () => {
    alert("Oops Image Uploading Failed....");
  };



  const captureFrame = async () => {
  const video = props.videoRef.current;
  const canvas = canvasRef.current;

  if (video && canvas) {
    const ctx = canvas.getContext("2d");
     const maxWidth = 440; // thumbnails ke liye enough hai
        const aspect = video.videoHeight / video.videoWidth;
        canvas.width = maxWidth;
        canvas.height = maxWidth * aspect;

    // 👇 video frame draw
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

    // 👇 image ko optimize karke base64 banao (JPEG 0.7 quality)
    const imageDataURL = canvas.toDataURL("image/jpeg", 0.7);
  
    const res1 = await  postData("videos/save-thumbnail", {
  videoId: appState.currentDBVideoId,
  image: imageDataURL, // base64
  folderPath:`${appState.assetsUrl}/thumbnails`
});

if(res1.success)
{
  console.log("save thumbnail on test bucket done....",res1.thumbnailUrl)

 setAppState((prevState) => ({
  ...prevState,
  videoArr: prevState.videoArr.map((video) =>
    video._id === prevState.currentDBVideoId
      ? { 
          ...video,
          thumbnail: res1.thumbnailUrl // 👈 sirf thumbnail update
        }
      : video
  ),
}));



     // 👇 UI ke liye state set karo
    setImageSrc(imageDataURL);
 
       
          window.dispatchEvent(
  new CustomEvent("thumbnail-updated", {
    detail: {
       videoId:appState.currentDBVideoId,
      thumbnailUrl: res1.thumbnailUrl
    }
  })
)
    
    


}
return;

    // 👇 cuePoint bhi update karo jaise pehle kar rahe the
    const json = await putData(`videos/updateVideo/${appState.currentDBVideoId}`, {
      cuePoint: props.currentTime,
    });

    if (json) {
      const currentVideoId = Number(appState.currentVideoId);
      const updatedAppState = {
        ...appState,
        videoArr: appState.videoArr.map((video, index) =>
          index === currentVideoId ? { ...video, cuePoint: json.video.cuePoint } : video
        ),
      };

      setAppState(updatedAppState);
      
	  
	  
	  
	   // 👇 LocalStorage me save/replace karo
    try {
      const key = `thumb_${appState.currentDBVideoId}`;
     
     
      localStorage.removeItem(key)
     
  const response = await postData("Videos/captureVideoId", { videoId: appState.currentDBVideoId });
  if(response)
  {
    console.log("RESPONSE....");
 localStorage.setItem(key, imageDataURL);
  window.dispatchEvent(new Event("thumbnail-updated"));
  }
  
    
    
       
      console.log("✅ Thumbnail saved in localStorage:", key);
    } catch (e) {
      if (e.name === "QuotaExceededError") {
        console.error("⚠️ LocalStorage quota exceeded, image not saved.");
      } else {
        console.error("⚠️ Error saving to localStorage:", e);
      }
    }
    }
  }
};


  const updateVideoTitleHandler=async()=>{

    
      
  toast.success("Title Update", {
                            position: "bottom-center",
                            autoClose: 500,
                          });
                          
                           
   

       const json = await putData(`videos/updateVideo/${appState.currentDBVideoId}`, {
                        title: videoTitle 
                      });
                      if (json) {                
                           
                        //console.log(appState.currentVideoId,"JSON =====",json.video.title);
                        const currentVideoId = Number(appState.currentVideoId);
                        const updatedAppState = {
                          ...appState, // Keep other properties the same
                          videoArr: appState.videoArr.map((video, index) => {
                            //console.log(`Processing video at index: ${index}`,typeof currentVideoId); // Debug log
                            if (index === currentVideoId) {
                              //console.log(`Updating video at index: ${index} with new title:`, json.video.title); // Log when update happens
                            }
                            return index === currentVideoId ? { ...video, title: json?.video?.title } : video;
                          }),
                        };
                        
                        //console.log("Updated AppState:", updatedAppState); // Log final state
                        
                        
                        setAppState(updatedAppState);
                      // Store updated state in localStorage
                      localStorage.setItem('appState', JSON.stringify(updatedAppState));

 
                      
                      
                      }
  }
    const handleUpdate=()=>{
        //console.log("handle update")
    }
  return (


    <div className='mt-2 px-4 space-y-2'>
  <canvas ref={canvasRef} style={{ display: "none" }}></canvas>
<label
        htmlFor="folder_name"
        className="block mb-2 text-sm font-medium text-yellow-800 dark:text-white"
      >
        Video Title
      
      </label>
<input
  type="text"
  id="folder_name"
  className=" w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm focus:ring-blue-500 focus:border-blue-500 block  p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
  value={videoTitle} // ✅ ab state se bind hai
  onChange={(e) => setVideoTitle(e.target.value)}
  required
   
/>

<button
          onClick={updateVideoTitleHandler}
          type="button"
          className="  w-full text-white bg-gradient-to-r bg-gray-800 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium  text-sm px-5 py-2.5"
        >
          Update
        </button>
       <label
  htmlFor="thumbnail"
  className="block mb-2 text-sm font-medium text-yellow-800 dark:text-white"
>
  Thumbnail
</label>

{isUploading ? (
  <div className="flex items-center justify-center w-full h-[150px] bg-gray-200">
    <FontAwesomeIcon icon={faSpinner} spin size="2x" className="text-yellow-800" />
  </div>
) : imageSrc ? (
  <div>
    <img
      src={imageSrc}
      alt="Captured Frame"
      className="w-full h-[150px]"
    />
  </div>
) : (
  <div className="bg-gray-400 border w-full h-[150px] flex items-center justify-center">
    <FontAwesomeIcon icon={faImage} />
  </div>
)}

 
      <div className='flex gap-1'>
    
          <div className="flex-grow" >
    <UploadImageVideoThumbnail  
      imgOnPrg={imgOnPrg} 
      imgUploadedDone={imgUploadedDone} 
      uploadFailed={uploadFailed} 
      data-dbvideoid={appState?.currentDBVideoId}
    />
  </div>
        
       
        <button
          onClick={captureFrame}
          type="button"
          className="  w-1/2 text-white bg-gradient-to-r bg-gray-800 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium  text-sm px-0 py-2.5"
        >
          Capture Image
        </button>
        </div>
    </div>
  )
}

export default VideoGeneralSetting